export default __webpack_public_path__ + "static/media/gaddige.1b7211e1.jpg";